import { render, staticRenderFns } from "./CardAverage.vue?vue&type=template&id=7e5ef8b8&scoped=true&"
import script from "./CardAverage.vue?vue&type=script&lang=js&"
export * from "./CardAverage.vue?vue&type=script&lang=js&"
import style0 from "./CardAverage.vue?vue&type=style&index=0&id=7e5ef8b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5ef8b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VTooltip})
